import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CONSTANTS_CRM, Outcome } from '@fitness-force/constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'outcome',
  templateUrl: './outcome.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class OutcomeComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  dataProperty: string = '';
  constructor() {}
  ngOnInit(): void {}

  getOutCome(value: number, row: any): Outcome | undefined {
    if (row != null) {
      if (row.tsk_type == 1)
        //call
        return CONSTANTS_CRM.CALL_OUTCOME.find(
          (element) => element.value == value,
        );
      else if (row.tsk_type == 5)
        //Tour
        return CONSTANTS_CRM.TOUR_OUTCOME.find(
          (element) => element.value == value,
        );
      else
        return CONSTANTS_CRM.CALL_OUTCOME.find(
          (element) => element.value == value,
        );
    } else {
      return CONSTANTS_CRM.CALL_OUTCOME.find(
        (element) => element.value == value,
      );
    }
  }
}
